export const getCardModifierIdsFromCartModifierList = cartModifierList => {
  let cartModifierIds = []
  cartModifierList.forEach(cartModifier => {
    cartModifierIds.push(cartModifier.id)
  })

  return cartModifierIds
}
